<script lang="ts">
  import { onMount } from "svelte";

  export let progress = 0;
  let ref: SVGSVGElement;
  let path: SVGPathElement;
  let totalLength: number = 0;
  let offset = 0;

  onMount(() => {
    path = ref.querySelector("#path1") as SVGPathElement;
    totalLength = path.getTotalLength();
    offset = totalLength - (progress / 100) * totalLength;
    path.style.strokeDasharray = totalLength.toString();
    path.style.strokeDashoffset = offset.toString();
  });

  const onProgressChange = (progress: number) => {
    if (!ref || !progress) return;
    offset = totalLength - (progress / 100) * totalLength;
    path.style.transition = "stroke-dashoffset 0.6s ease-in-out";
    path.style.strokeDashoffset = offset.toString();
  };

  $: onProgressChange(progress);
</script>

<svg bind:this={ref} viewBox="0 0 157.5263 19.116064" version="1.1" id="svg1" data-testid="progress">
  <defs id="defs1" /><g id="layer1" transform="translate(-0.52916503,-1.127569)">
    <path
      style="display:inline;opacity:1;fill:none;stroke:#C2CAD1;stroke-width:1.32292;stroke-linecap:round;stroke-opacity:0.905605;"
      d="m 1.190625,2.778125 c 0,0 12.303125,-3.17499939 20.769791,2.9104166 4.233334,3.0427082 12.695293,9.1718734 17.487305,10.7404294 2.75332,0.901237 5.736202,0.98051 6.655924,0.768945 6.753892,-1.553605 11.471506,-4.217845 10.914063,-8.5658849 -0.165365,-1.2898436 -1.522031,-2.5795447 -3.29177,-1.9510879 -1.036453,0.368058 -1.624365,1.1714717 -1.801459,1.9510879 -0.269692,1.1872609 -0.09922,5.2255199 4.233333,7.7721349 3.325074,1.954433 8.459625,3.795379 13.592968,2.976563 5.390885,-0.859896 13.196094,-5.655469 15.841928,-7.507552 2.645833,-1.852083 10.52692,-6.2504184 16.503382,-6.5484376 2.94361,-0.1467846 5.70347,0.233711 8.28356,1.1840073 2.58009,0.9502962 5.17712,2.75167 6.03702,3.8761493 1.71979,2.248958 2.48046,6.217708 -0.42996,6.085416 -2.91041,-0.132292 -2.61275,-3.63802 -1.42213,-5.22552 1.19063,-1.5875004 4.0693,-6.0073293 13.89063,-8.5328129 4.63021,-1.1906249 9.3347,-1.0641355 13.14648,-0.5374349 6.57359,0.908322 12.25428,3.1171224 15.79232,5.1014974"
      id="path2" />
    <path
      style="display:inline;opacity:1;fill:none;stroke:#8b54ff;stroke-width:1.32292;stroke-linecap:round;stroke-opacity:0.905605;"
      d="m 1.190625,2.778125 c 0,0 12.303125,-3.17499939 20.769791,2.9104166 4.233334,3.0427082 12.695293,9.1718734 17.487305,10.7404294 2.75332,0.901237 5.736202,0.98051 6.655924,0.768945 6.753892,-1.553605 11.471506,-4.217845 10.914063,-8.5658849 -0.165365,-1.2898436 -1.522031,-2.5795447 -3.29177,-1.9510879 -1.036453,0.368058 -1.624365,1.1714717 -1.801459,1.9510879 -0.269692,1.1872609 -0.09922,5.2255199 4.233333,7.7721349 3.325074,1.954433 8.459625,3.795379 13.592968,2.976563 5.390885,-0.859896 13.196094,-5.655469 15.841928,-7.507552 2.645833,-1.852083 10.52692,-6.2504184 16.503382,-6.5484376 2.94361,-0.1467846 5.70347,0.233711 8.28356,1.1840073 2.58009,0.9502962 5.17712,2.75167 6.03702,3.8761493 1.71979,2.248958 2.48046,6.217708 -0.42996,6.085416 -2.91041,-0.132292 -2.61275,-3.63802 -1.42213,-5.22552 1.19063,-1.5875004 4.0693,-6.0073293 13.89063,-8.5328129 4.63021,-1.1906249 9.3347,-1.0641355 13.14648,-0.5374349 6.57359,0.908322 12.25428,3.1171224 15.79232,5.1014974"
      id="path1" />
    <g id="g3">
      <path
        style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:1.32292;stroke-linecap:round;stroke-dasharray:none;stroke-opacity:0.905605"
        d="m 116.68538,9.6696939 c 0,0 -0.34726,-0.4175456 -0.99219,-0.901237 0.51677,-0.5539713 0.62426,-0.7069335 0.62426,-0.7069335 l 1.19062,1.0087239 z"
        id="path3" />
      <path
        style="opacity:1;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:1.32292;stroke-linecap:round;stroke-dasharray:none;stroke-opacity:0.905605"
        d="m 54.715522,14.487 -0.869065,-1.016616 0.222168,-0.724968 0.502801,-0.05262 1.0933,1.216076 z"
        id="path2" />
    </g>
  </g>
</svg>

<style>
  svg {
    width: 100%;
    min-width: 240px;
    max-height: 35px;
  }
</style>
